import { POBillToSettingsCard } from '@webapp/modules/purchasing/features/set-po-bill-to-settings/views/POBillToSettingsCard'
import {
  type IUsePOBillToSettingsPresenterProps,
  usePOBillToSettingsPresenter,
} from './usePOBillToSettingsPresenter'

export interface IPOBillToSettingsPresenterProps extends IUsePOBillToSettingsPresenterProps {
  // Set while the saved preferences are unavailable, so the fields cannot
  // persist the displayed defaults over the tenant's real settings
  isDisabled?: boolean
}

export const POBillToSettingsPresenter = ({
  primaryCategory,
  contact,
  contactUser,
  isLoadingContactUser,
  isDisabled = false,
}: IPOBillToSettingsPresenterProps) => {
  const {
    states: {
      primaryCategory: primaryCategoryValue,
      isSavingPrimaryCategory,
      contactMode,
      selectedContactUser,
      isContactUserRequired,
      isSavingContact,
    },
    methods: {
      onPrimaryCategoryChange,
      onContactModeChange,
      onContactUserChange,
    },
  } = usePOBillToSettingsPresenter({
    primaryCategory,
    contact,
    contactUser,
    isLoadingContactUser,
  })

  return (
    <POBillToSettingsCard
      primaryCategory={primaryCategoryValue}
      contactMode={contactMode}
      selectedContactUser={selectedContactUser}
      isContactUserRequired={isContactUserRequired}
      isSavingPrimaryCategory={isSavingPrimaryCategory}
      isSavingContact={isSavingContact}
      isLoadingContactUser={isLoadingContactUser}
      isDisabled={isDisabled}
      onPrimaryCategoryChange={onPrimaryCategoryChange}
      onContactModeChange={onContactModeChange}
      onContactUserChange={onContactUserChange}
    />
  )
}

POBillToSettingsPresenter.displayName = 'POBillToSettingsPresenter'
